import {Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import QuoteDetails from "../../model/quote/QuoteDetails";

/**
 * Gets quote details.
 * @param quoteId
 * @param {RootState} state State of the redux.
 * @returns {Option<QuoteDetails>} quote details.
 */
export function getQuoteDetails(quoteId: string, state: RootState): Option<QuoteDetails> {
	const quoteDetails = state.quote.quotesMap[quoteId];
	return option(quoteDetails);
}
